'use strict'

module.exports = class PageSpinner extends Backbone.View
  initialize: ({@topMargin} = {}) ->
    @options = _.extend {}, LOADING_OPTIONS
    @isRunning = false

  render: ->
    return if @isRunning
    @isRunning = true
    @options.topMargin = @topMargin
    @_insertSpinner()
    @start()

  close: ->
    return unless @isRunning
    @isRunning = false
    @stop()

  startRunning: ->
    @isRunning = true

  stopRunning: ->
    @isRunning = false

  LOADING_OPTIONS =
    fullscreenOverlay: false
    label: 'Loading...'

  start: ->
    # adjust the spinner to fit the page
    if @options.topMargin?
      topMargin = @options.topMargin
    else if $(document).scrollTop() > 200
      topMargin = @options.baseTop + $(document).scrollTop() - 250
    else
      topMargin = @options.baseTop + 100

    @spinnerBack.css('top', topMargin)
    @overlay.show()
    @$el

  _insertSpinner: ->
    unless @$el.children('#load-overlay').length
      @overlay = $('<div/>', id: 'load-overlay')
      @spinnerBack = $('<div/>', id: 'spinner-back')
      @spinner = $('<div/>', class: 'icon-g-loader', id: 'spinner')

      @spinner.appendTo @spinnerBack
      @spinnerBack.appendTo @overlay

      @$el.append @overlay

  stop: ->
    @overlay.hide()
    @$el
